namespace GeniuzPOS.PosShift {
    export interface PosTranRecvRow {
        Id?: number;
        DocNo?: string;
        LineItemNo?: number;
        PaymentType?: number;
        LineItemType?: number;
        ReceiptAmt?: number;
        RefType?: string;
        RefNo?: string;
        PointBurn?: number;
        CurrencyCode?: string;
        CurrencyAmt?: number;
        ExchangeRate?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace PosTranRecvRow {
        export const idProperty = 'Id';
        export const nameProperty = 'DocNo';
        export const localTextPrefix = 'PosShift.PosTranRecv';
        export const lookupKey = 'PosShift.PosTranRecv';

        export function getLookup(): Q.Lookup<PosTranRecvRow> {
            return Q.getLookup<PosTranRecvRow>('PosShift.PosTranRecv');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            DocNo = "DocNo",
            LineItemNo = "LineItemNo",
            PaymentType = "PaymentType",
            LineItemType = "LineItemType",
            ReceiptAmt = "ReceiptAmt",
            RefType = "RefType",
            RefNo = "RefNo",
            PointBurn = "PointBurn",
            CurrencyCode = "CurrencyCode",
            CurrencyAmt = "CurrencyAmt",
            ExchangeRate = "ExchangeRate",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
